import { render, staticRenderFns } from "./FormItemKeyword.vue?vue&type=template&id=1a854328"
import script from "./FormItemKeyword.vue?vue&type=script&lang=js"
export * from "./FormItemKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports